import React, { useRef, useState } from 'react'
import { doc, setDoc, Timestamp } from "firebase/firestore"
import { auth, db } from '../../firebase';
import Form from './Form';



function SignUpCompletionForm(props) {

  async function addToDatabase(data) {
    console.log('creating document')

    const nextMonth = (new Date().getTime() + 2592000000) / 1000;

    await setDoc(doc(db, "users", auth.currentUser.uid), {
      ...data,
      expiry_date: new Timestamp(nextMonth, 0),
      credits: 5,
      id: auth.currentUser.uid,
    });
    props.onClick();

  }


  return (
    <div style={{ zIndex: '99', width: '100%', height: 'calc(100vh - 50px)' }}>
      <Form sendResult={(data) => {
        addToDatabase(data);
        console.log('final data', data);
      }} />
    </div>

  )
}

export default SignUpCompletionForm
